import { reactive, ref, computed, watch } from '@vue/composition-api'
import router from '@/router'
import store from '@/store'
import Vue from 'vue'
import * as apiQA from '@/api/qa'
import * as apiNote from '@/api/note'
import * as apiCommon from '@/api/common'
import * as _ from 'lodash'
import { SCROLL_INTERVAL_DELAY, SCROLL_INTERVAL_MAX_COUNT } from '@/util/constants'

/**
 * QA PDF画面
 */
export const getGroup = (props, context) => {

  // URLのQA IDを監視する
  watch(() => props.qaId, (newVal, oldVal) => {
    if (oldVal) {

      store.dispatch('qa/setQaId', newVal)

      // ※目次エリアはツリーの開閉情報維持のためリロードしない
      // 目次スクロール位置指定用QAIDを設定
      group1.scrollTopQAID = store.state.qa.qaId

      // 本文（メインエリア）を更新
      group1.updateMainArea()

    }
  })

  const group1 = reactive({

    // ### ヘッダエリア ###
    manualRecomentation: '', // 追録号数(フロントエンドログイン時に表示）
    manualRecomentationDisp: computed(() => {
      return (group1.manualRecomentation === '') ? '-' : group1.manualRecomentation
    }),

    // ### 目次エリア ###

    // QAID
    qaId: computed(() => {
      return store.state.qa.qaId
    }),
    // QAタイトル
    qaTitle: '',

    // QAコード
    qaCode: '',

    // ### 本文エリア ###
    // 設問詳細タイプ（2:QA 3:あらまし）
    type: 0,

    // あらまし
    contents: '',

    // 本文データロード完了フラグ
    isMainContentsLoaded: false,

    // ### その他 ###

    // フロントエンドログインフラグ（管理システムから遷移してきた場合）
    isFrontendLogin: computed(() => {
      // return (store.state.profile.login_type === 2)
      return (false)
    }),
    // フロントエンドログイン情報表示欄の高さ
    frontendLoginInfoAreaHeight: computed(() => {
      return (group1.isFrontendLogin) ? 50 : 0
    }),

    // 目次スクロール位置指定用QAID
    scrollTopQAID: 0,

    // 現在のリビジョン名
    revisionName: computed(() => {
      // if (store.state.qa.searchIndexId === 0) {
      //   return '最新'
      // } else {
      return store.state.qa.revisionName
      // }
    }),

    /**
     * 初期表示
     */
    init: () => {

      // 初期化
      store.dispatch('qa/setRevisionName', '')

      if (
        store.state.common.device === 'pc' &&
        (!_.isNaN(props.noteId) && props.noteId !== 0 &&
        !_.isNaN(props.rowId) && props.rowId !== 0)
      ) {
        // ノート一覧からの遷移で書籍削除の場合
        store.dispatch('qa/setBookId', 0) // 書籍IDが設定されているが後ろのQAIDから書籍情報を取得する処理を実行するため書籍IDは0に設定しておく
        store.dispatch('qa/setBookName', '')
        store.dispatch('qa/setQaId', props.qaId)
        store.dispatch('qa/setSearchIndexId', 0) // 検索インデックスは初期表示は最新にしておく
        store.dispatch('qa/setNumberCarouselVisible', 0)
        store.dispatch('qa/setBookRevisionId', 0)
        store.dispatch('qa/setNoteId', props.noteId)
        store.dispatch('qa/setNoteRowId', props.rowId)
      } else if (
        !_.isNaN(props.qaId) && props.qaId !== 0
      ) {
        // QAIDを指定したURLで直接アクセスした場合
        store.dispatch('qa/setBookId', 0)
        store.dispatch('qa/setBookName', '')
        store.dispatch('qa/setQaId', props.qaId)
        store.dispatch('qa/setSearchIndexId', 0) // 検索インデックスは初期表示は最新にしておく
        store.dispatch('qa/setNumberCarouselVisible', 0)
        store.dispatch('qa/setBookRevisionId', 0)
        store.dispatch('qa/setNoteId', 0)
        store.dispatch('qa/setNoteRowId', 0)
      } else {
        // デフォルトの遷移
        store.dispatch('qa/setBookRevisionId', 0)
      }

      // 目次スクロール位置指定用QAIDを設定
      group1.scrollTopQAID = store.state.qa.qaId

      // 既存ロジックによる遷移もしくはノート関連の情報が遷移されていないときには書籍情報取得APIのコールからの初期動作を行う
      if (store.state.qa.bookId === 0 && store.state.qa.noteId === 0 && store.state.qa.noteRowId === 0) {
        // 書籍IDが0の場合（直接アクセスした場合、書籍一覧、書式DL画面のQAタイトルをクリックしてアクセスした場合）

        // QA IDから書籍IDを取得するために書籍情報取得APIをコール
        const params = {}
        params.qa_id = store.state.qa.qaId
        params.search_index_id = 0 // 検索インデックスは指定する必要ないので最新にしておく

        apiQA.fetchBookInfo(params)
          .then(response => {
            if (response) {
              const { data } = response

              // 書籍IDをstoreに保存
              store.dispatch('qa/setBookId', data.book_id)
              store.dispatch('qa/setBookName', data.book_name)

              // リビジョン表示部に現在のリビジョンを表示(初期処理用)
              group1.updateCurrentRevisionForInit()
            }
          })
      } else {
        // 書籍IDが設定されている場合（QA一覧から遷移してきた場合）

        // リビジョン表示部に現在のリビジョンを表示(初期処理用)
        group1.updateAllArea()
      }
    },

    /**
     * リビジョン表示部に現在のリビジョンを表示(初期処理用)
     */
    updateCurrentRevisionForInit: async () => {

      // 初期化
      store.dispatch('qa/setSearchIndexId', 0)
      store.dispatch('qa/setRevisionName', '') // 「最新」を設定すると、一瞬表示されてしまうので空文字にしておく

      // リビジョン一覧API（リビジョン切替用）をコール
      const params = {}
      params.book_id = store.state.qa.bookId
      params.qa_id = store.state.qa.qaId

      await apiQA.listRevisionsForChange(params)
        .then(async (response) => {
          if (response) {
            const { data } = response

            // 最新のQAID
            const lastestQaId = data.qa_id

            const packages = data.packages ?? []

            // 現在選択しているQA ID
            const selectedQaId = store.state.qa.qaId

            // 各エリアを更新
            group1.updateAllArea()
          }
        })
    },

    /**
     * 各エリアを更新
     */
    updateAllArea: () => {

      // 本文（メインエリア）を更新
      group1.updateMainArea()
    },

    /**
     * 本文（メインエリア）を更新
     */
    updateMainArea: () => {

      // QA詳細取得APIをコール
      const params = {}
      group1.isMainContentsLoaded = false

      if (store.state.qa.noteId === 0 && store.state.qa.noteRowId === 0) {
        params.qa_id = store.state.qa.qaId
        params.search_index_id = store.state.qa.searchIndexId
        params.not_save_browsing_history = 1

        apiQA.detail(params)
          .then(response => {
            if (response) {
              const { data } = response

              group1.type = data.type
              const fileId = data.file_id

              // 設問詳細タイプ
              if (group1.type === 2) {
                // 2:QAの場合

                // PDFのURL
                group1.pdfURLStatic = apiCommon.getFetchFileAPIURL(fileId, false)

              } else if (group1.type === 3) {
                // 3:あらましの場合

                // あらましはPDF表示できないのでエラーポップアップ
                var title = 'エラー'
                var text = '対象情報は閲覧できません。'

                store.dispatch('common/showNotice', { title: title, text: text })
              }

              // QAタイトル
              group1.qaTitle = data.title ?? '-'
              store.dispatch('common/addTitle', group1.qaTitle)

              // 印刷タイトルを設定
              store.dispatch('print/setTitle', group1.qaTitle)

              // 追録号数
              group1.manualRecomentation = data.manual_recomentation

              // QAコード
              group1.qaCode = data.qa_code

              // リロードでない
              const prevUrl = location.href
              const prevUrlComp = store.state.qa.prev_url
              store.dispatch('qa/setPrevUrlStr', prevUrl)
            }
          })
          .finally(() => {
            // 設問詳細タイプが「3:あらまし」の場合
            group1.isMainContentsLoaded = true
          })
      } else {
        params.id = store.state.qa.noteId
        params.note_row_id = store.state.qa.noteRowId

        apiNote.qaDetail(params)
          .then(response => {
            if (response) {
              const { data } = response

              // 設問詳細タイプ
              group1.type = 2

              // PDFのURL
              group1.pdfURLStatic = apiCommon.getFetchFileAPIURL(data.file_id, false) + '&shown_private=1'

              // QAタイトル
              group1.qaTitle = data.title ?? '-'
              store.dispatch('common/addTitle', group1.qaTitle)

              // 印刷タイトルを設定
              store.dispatch('print/setTitle', group1.qaTitle)

              // 追録号数
              // group1.manualRecomentation = data.manual_recomentation

              // QAコード
              // group1.qaCode = data.qa_code
            }
          })
          .finally(() => {
            // 設問詳細タイプが「3:あらまし」の場合
            group1.isMainContentsLoaded = true
          })
      }
    }
  })

  return group1
}
